import { useState, useEffect, useRef } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { MultiSelect } from 'primereact/multiselect';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import '../../../assets/css/teacherMasterDetail.css';
import { Checkbox } from 'primereact/checkbox';
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import { InputTextarea } from 'primereact/inputtextarea';
import api from "../../../utils/apiClient";
import CommonConfig from '../../../utils/constant';
import Toast from '../../Shared/Toast/Toast';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { apiBase } from '../../../utils/config';
import DeleteConfirmation from '../../Dialogs/DeleteConfirmation';
import { Dialog } from 'primereact/dialog';
import UploadFile from '../../UploadFile/UploadFile';
import { useCatchResponse } from '../../../utils/useCatchResponse';
import placeHolderImage from '../../../assets/images/UserImage.png';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Badge } from 'primereact/badge';

const ViewEditParentDetails = (props) => {
    const { catchResponse } = useCatchResponse();
    const navigate = useNavigate();
    const fileUploadRef = useRef(null);
    const [securityUserID, setSecurityUserID] = useState("");
    const [personalDetailId, setPersonalDetailId] = useState('');
    const [fullName, setFullName] = useState("");
    const [parentId, setParentId] = useState("");
    const [mobileNumber, setMobileNumber] = useState("");
    const [emailAddress, setEmailAddress] = useState("");
    const [emailIdErrText, setEmailIdErrText] = useState('');
    const [emailIdErr, setEmailIdErr] = useState(false);
    const [aadharNo, setAadharNo] = useState('');
    const [selectedGender, setSelectedGender] = useState(null);
    const [aadharOTP, setAadharOTP] = useState('');
    const [isAadharVerify, setIsAadharVerify] = useState(false);
    const [dob, setDob] = useState('');
    const [age, setAge] = useState('');
    const [currentAddress, setCurrentAddress] = useState('');
    const [permanentAddress, setPermanentAddress] = useState('');
    const [qualification, setQualification] = useState('');
    const [occupation, setOccupation] = useState('');
    const [designation, setDesignation] = useState('');
    const [income, setIncome] = useState('');
    const [isEdit, setIsEdit] = useState(false);
    const genderOptions = [{ label: 'Male', value: 'male' }, { label: 'Female', value: 'female' }];
    const [childrens, setChildrens] = useState([]);
    const [childrensErr, setChildrensErr] = useState(false);
    const [childrensErrText, setChildrensErrText] = useState('');
    const [childrensList, setChildrensList] = useState([]);
    const [profilePath, setProfilePath] = useState(null);
    const [isDeleteConfirmation, setIsDeleteConfirmation] = useState(false);
    const [isRandom, setIsRandom] = useState(false);
    const [previewProfilePath, setPreviewProfilePath] = useState('');
    const [oldPermanentAddress, setOldPermanentAddress] = useState('');
    const [bloodList, setBloodList] = useState([]);
    const [selectedBloodGroup, setSelectedBloodGroup] = useState(null);
    const [childrensDetailList, setChildrensDetailList] = useState([]);
    const [imageQuality, setImageQuality] = useState(0.2);


    useEffect(() => {
        const fetchData = async () => {
            try {
                Loader.show();
                const loginData = CommonConfig.loginData();
                setSecurityUserID(loginData?._id);
                setIsEdit(props?.location?.state?.isEdit)
                await GetChildrensList(loginData?._id);
                await GetConfigurationData(loginData?._id);

                await GetBloodList();
                await getUserDetailById();
                await getPersonDetail(loginData?._id);
            } catch (error) {
                Loader.hide();
                console.error('Error in useEffect:', error);
            } finally {
                Loader.hide();
            }
        };
        fetchData();
    }, []);

    const GetConfigurationData = async (id) => {
        try {
            let data = {
                id: id,
            }
            await api.post(APIConstant.path.GetGeneralConfigurationDetail, data).then(async response => {
                let res = response;
                if (res.success) {
                    setImageQuality(!CommonConfig.isEmpty(res?.data?.ParentConfig) ? res?.data?.ParentConfig : 0.2);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetBloodList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getBloodList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setBloodList(res.data.map(x => ({
                        label: x?.BloodName,
                        value: x?._id
                    })));
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const getUserDetailById = async () => {
        try {
            let data = {
                id: props?.location?.state?.userId,
            };
            await api
                .post(APIConstant.path.getUserById, data)
                .then(async (response) => {
                    let res = await response;
                    if (res.success) {
                        Loader.hide();
                        setFullName(res?.data?.Name);
                        setMobileNumber(res?.data?.Phone);
                        setEmailAddress(res?.data?.Email);
                        setProfilePath(res?.data?.ProfilePhotoUrl ? `${apiBase}/UserProfilePic/${res?.data?.ProfilePhotoUrl}` : placeHolderImage);
                    }
                })
                .catch((err) => {
                    Loader.hide();
                    console.log(err);
                });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    };

    const GetAllChildrensList = async (id, childrenData) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getUser, data).then(async response => {
                let res = response;
                if (res.success) {
                    const studentData = childrenData ? childrenData?.split(',') : [];
                    const filteredStudentsList = res?.data?.filter(student => student?.UserType === 'Student' && student?.Status === 'Active' && studentData?.includes(String(student?._id)))
                        .map(student => ({
                            label: `${student?.Name} (${student?.Phone})`,
                            value: student?._id,
                        }));
                    setChildrensList((prevList) => [...prevList, ...filteredStudentsList]);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetChildrensList = async (id) => {
        try {
            let data = {
                UserID: id,
                genderType: selectedGender
            }
            await api.post(APIConstant.path.getChildreenDropDownList, data).then(async response => {
                let res = response;
                if (res.success) {
                    const filteredStudentsList = res.data.map(student => ({
                        label: `${student?.Name} (${student?.Phone})`,
                        value: student?._id,
                    }));

                    setChildrensList((prevList) => {
                        const combined = [...prevList, ...filteredStudentsList];

                        const uniqueMap = new Map();
                        combined.forEach(item => {
                            uniqueMap.set(item.value, item);
                        });

                        return Array.from(uniqueMap.values());
                    });

                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const getPersonDetail = async (ID) => {
        try {
            let data = {
                id: props?.location?.state?.userId,
            };
            await api
                .post(APIConstant.path.GetPersonalDetailById, data)
                .then(async (response) => {
                    let res = await response;
                    if (res.success) {
                        Loader.hide();
                        setPersonalDetailId(res?.data?._id);
                        setParentId(res?.data?.ProfileId);
                        setAadharNo(res?.data?.AadharNo);
                        setSelectedGender(res?.data?.Gender);
                        setDob(res?.data?.DOB ? new Date(res?.data?.DOB) : '');
                        setAge(res?.data?.Age);
                        setSelectedBloodGroup(res?.data?.BloodGroup || '');
                        setCurrentAddress(res?.data?.CurrentAddress ?? '');
                        setPermanentAddress(res?.data?.PermanentAddress ?? '');
                        setQualification(res?.data?.Qualification);
                        setOccupation(res?.data?.Occupation);
                        setDesignation(res?.data?.Designation);
                        setChildrens(res?.data?.TypeId ? res?.data?.TypeId.split(',') : []);
                        setIncome(res?.data?.Income);
                        setChildrensDetailList(res?.data?.ParentChildList || '');
                        await GetAllChildrensList(ID, res?.data?.TypeId);
                    }
                })
                .catch((err) => {
                    Loader.hide();
                    console.log(err);
                });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    };

    const saveDetails = async (e) => {
        await AddEditUserDetail();
        await AddEditPersonalDetail();
        navigate(-1)
    }

    const AddEditUserDetail = async () => {
        try {
            const formData = new FormData();
            formData.append("id", props?.location?.state?.userId);
            formData.append("Name", fullName.trim().replace(/\s+/g, ' '));
            formData.append("Email", emailAddress);
            formData.append("Phone", mobileNumber);
            formData.append("IsNoLogin", true);
            if (profilePath && profilePath.type) {
                formData.append("userProfilePic", profilePath);
            } else if (CommonConfig.isEmpty(profilePath)) {
                formData.append("userProfilePic", '');
            }
            Loader.show();
            await api.post(APIConstant.path.AddUpdateUser, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
                .then(async (response) => {
                    let res = response;
                    if (res.success) {
                    } else {
                        Toast.error({ message: res.message });
                    }
                    Loader.hide();
                })
                .catch((err) => {
                    console.error(err);
                    Toast.error({ message: 'Failed to update user details' });
                    Loader.hide();
                });
        } catch (err) {
            console.log(err);
            Toast.error({ message: 'An error occurred' });
            Loader.hide();
            catchResponse(err);
        }
    };

    const AddEditPersonalDetail = async (e) => {
        try {
            let data = {
                PersonalId: personalDetailId,
                UserId: props?.location?.state?.userId,
                AadharNo: aadharNo,
                Gender: selectedGender,
                TypeId: childrens.length ? (childrens.length > 1 ? childrens.join(',') : childrens[0]) : '',
                Age: age,
                DOB: dob ? moment(dob).format("YYYY-MM-DD") : '',
                CurrentAddress: currentAddress,
                PermanentAddress: permanentAddress,
                BloodGroup: selectedBloodGroup,
                Qualification: qualification,
                Occupation: occupation,
                Designation: designation,
                Income: income,
                CreatedBy: securityUserID,
            };
            Loader.show();
            await api.post(APIConstant.path.AddPersonalDetail, data).then(async response => {
                let res = response;
                if (res.success) {
                    Toast.success({ message: 'Details Updated' });
                    Loader.hide();
                } else {
                    Toast.error({ message: res.message });
                    Loader.hide();
                }
            })
                .catch((err) => {
                    Loader.hide();
                });
        } catch (err) {
            console.log(err);
            Loader.hide();
            catchResponse(err);
        }
    };

    const handleChange = (e, type) => {
        const value = e.target.value;
        const alphanumericValue = value.replace(/[^a-zA-Z0-9\s!@#$%^&*\u0A80-\u0AFF\u0900-\u097F\s]/g, '');
        const numericValue = value.replace(/[^0-9]/g, '');
        if (type === 'FullName') {
            setFullName(alphanumericValue);
        } else if (type === 'MobileNo') {
            setMobileNumber(numericValue);
        } else if (type === 'AadharNo') {
            setAadharNo(numericValue);
        } else if (type === 'Qualification') {
            setQualification(alphanumericValue);
        } else if (type === 'Occupation') {
            setOccupation(alphanumericValue);
        } else if (type === 'Designation') {
            setDesignation(alphanumericValue);
        } else if (type === 'Income') {
            setIncome(numericValue);
        }
    };

    const handleEmailChange = (e) => {
        const value = e.target.value;
        const maxLength = 50;
        if (value.length <= maxLength) {
            setEmailAddress(value);
        }
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailPattern.test(value)) {
            setEmailIdErr(true);
            setEmailIdErrText('Please enter a valid email address.');
        } else {
            setEmailIdErr(false);
            setEmailIdErrText('');
        }
    };

    const calculateAge = (dob) => {
        if (!dob) return '';
        const today = new Date();
        const birthDate = new Date(dob);

        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDifference = today.getMonth() - birthDate.getMonth();

        if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }

        return age;
    };

    const handleDobChange = (e) => {
        const selectedDob = e.value;
        setDob(selectedDob);
        setAge(calculateAge(selectedDob));
    };

    const handleFileSelect = (e) => {
        const selectedFile = e.files[0];
        if (!selectedFile) return;
        const img = new Image();
        img.onload = async () => {
            const aspectRatio = img.width / img.height;
            const expectedRatio = 3 / 4;
            const tolerance = 0.01;

            if (Math.abs(aspectRatio - expectedRatio) > tolerance) {
                if (fileUploadRef.current) {
                    fileUploadRef.current.clear();
                }
                Toast.error({ message: 'The image must have a 3:4 aspect ratio.' });
                return;
            }
            const canvas = document.createElement('canvas');
            const maxWidth = 300;
            const width = maxWidth;
            const height = width / aspectRatio;

            canvas.width = width;
            canvas.height = height;

            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, width, height);

            canvas.toBlob(
                (blob) => {
                    if (blob) {
                        const compressedFile = new File([blob], selectedFile.name, {
                            type: 'image/jpeg',
                            lastModified: Date.now()
                        });

                        setProfilePath(compressedFile);
                        const compressedURL = URL.createObjectURL(blob);
                        setPreviewProfilePath(compressedURL);
                    }
                },
                'image/jpeg',
                imageQuality
            );
        };

        img.onerror = () => {
            if (fileUploadRef.current) {
                fileUploadRef.current.clear();
            }
            Toast.error({ message: 'Error loading the image.' });
        };

        const reader = new FileReader();
        reader.onload = (event) => {
            img.src = event.target.result;
        };
        reader.readAsDataURL(selectedFile);
    };

    const renderFooter = () => (
        <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
            <Button
                label="Cancel"
                className="btn-text-action-secondary"
                onClick={handleClose}
            />
            <Button
                label="Delete"
                className="btn-text-action-primary"
                onClick={() => {
                    handleClose();
                    setProfilePath("");
                    setPreviewProfilePath('');
                    if (fileUploadRef.current) {
                        fileUploadRef.current.clear();
                    }
                }}
            />
        </div>
    );

    const handleClose = () => {
        setIsDeleteConfirmation(false)
    };

    const handleCheckBox = (e, type) => {
        setIsRandom(e.checked);
        if (e.checked) {
            setOldPermanentAddress(permanentAddress);
            setPermanentAddress(currentAddress);
        } else {
            setPermanentAddress(oldPermanentAddress);
            setOldPermanentAddress('');
        }
    }

    const handleDelete = (e) => {
        setIsDeleteConfirmation(true)
    };

    const actionBodyTemplateSrNo = (data, props) => {
        return props.rowIndex + 1;
    };

    const handleGender = (value) => {
        setSelectedGender(value);
        GetChildrensList(securityUserID);
    }

    return (
        <div className="student-master-container">
            <div className="heading-area p-d-flex p-ai-center p-jc-between">
                <div className="p-d-flex p-ai-center">
                    <i className="pi pi-arrow-left" onClick={() => navigate('/parent-master')}></i>
                    <h2>{!isEdit ? 'View' : 'Edit'} Parent Master</h2>
                </div>
                {!isEdit && (
                    <Button
                        label="Edit"
                        icon="pi pi-pencil"
                        className="btn-text-action-primary"
                        onClick={() => setIsEdit(true)}
                    />
                )}
            </div>
            <div className='student-master-form'>
                <div className='student-profile-header p-d-flex'>
                    <div className="p-d-flex">
                        <div style={{ height: 200, width: 210 }}>
                            <UploadFile label='' note='' preview={previewProfilePath} original={profilePath} uploadHandler={handleFileSelect} uploadRef={fileUploadRef} handleDelete={handleDelete} isEditAllow={isEdit} aspectRatio={3 / 4} />
                        </div>
                        <div className="student-header-profile-info p-pl-2">
                            <div>
                                <h2 className='p-text-justify'>{fullName}</h2>
                                <div className='p-d-flex p-ai-center'>
                                    <Badge value={`Parent ID - ${parentId ?? ''}`} className='common-badge' />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="form-section p-mb-0 p-mt-3">
                    <div className="p-grid">
                        <div className="p-col-12 p-md-3">
                            <div className="custom-inputs">
                                <label className='p-d-block' htmlFor="fullName">Full Name</label>
                                <InputText className='p-w-100 p-mt-1' id="fullName" value={fullName} disabled={!isEdit} maxLength={20} onChange={(e) => handleChange(e, 'FullName')} />
                            </div>
                        </div>
                        <div className="p-col-12 p-md-3">
                            <div className="custom-inputs">
                                <label className='p-d-block' htmlFor="aadhar">Aadhar</label>
                                <div className="p-inputgroup p-d-flex p-ai-lg-baseline p-mt-1">
                                    <InputText className='p-w-100' id="aadhar" disabled={!isEdit} maxLength={12} value={aadharNo} onChange={(e) => handleChange(e, 'AadharNo')} />
                                    <Button className='p-m-0' label="Verify" disabled={!isEdit} />
                                </div>
                            </div>
                        </div>
                        <div className="p-col-12 p-md-3">
                            <div className="custom-inputs">
                                <label className='p-d-block' htmlFor="emailId">Email ID</label>
                                <InputText className='p-w-100 p-mt-1' id="emailId" value={emailAddress} disabled={!isEdit} onChange={(e) => handleEmailChange(e)} />
                            </div>
                        </div>
                        <div className="p-col-12 p-md-3">
                            <div className="custom-inputs">
                                <label className='p-d-block' htmlFor="mobileNo">Contact No.</label>
                                <InputText className='p-w-100 p-mt-1' id="mobileNo" value={mobileNumber} disabled={!isEdit} maxLength={10} onChange={(e) => handleChange(e, 'MobileNo')} />
                            </div>
                        </div>
                        <div className="p-col-12 p-md-3">
                            <div className="custom-inputs">
                                <label className='p-d-block' htmlFor="dob">Date of Birth</label>
                                <Calendar className='p-w-100 p-mt-1' id="dob" value={dob} onChange={(e) => handleDobChange(e)} disabled={!isEdit} dateFormat='dd/mm/yy' maxDate={new Date} />
                            </div>
                        </div>
                        <div className="p-col-12 p-md-3">
                            <div className="custom-inputs">
                                <label className='p-d-block' htmlFor="age">Age</label>
                                <InputText className='p-w-100 p-mt-1' id="age" maxLength={2} value={age} disabled />
                            </div>
                        </div>
                        <div className="p-col-12 p-md-3">
                            <div className="custom-inputs">
                                <label className='p-d-block' htmlFor="gender">Gender</label>
                                <Dropdown className='p-w-100 p-mt-1' id="gender" disabled={!isEdit} value={selectedGender} options={genderOptions} onChange={(e) => handleGender(e.value)} placeholder="Select Gender" filter
                                    showClear />
                            </div>
                        </div>
                        <div className="p-col-12 p-md-3">
                            <div className="custom-inputs">
                                <label className='p-d-block' htmlFor="bloodGroup">Blood Group</label>
                                <Dropdown className='p-w-100 p-mt-1' id="bloodGroup" disabled={!isEdit} value={selectedBloodGroup} options={bloodList} onChange={(e) => setSelectedBloodGroup(e.value)} placeholder="Select Blood Group" filter
                                    showClear />
                            </div>
                        </div>
                        <div className="p-col-12 p-md-3">
                            <div className="custom-inputs">
                                <label className='p-d-block' htmlFor="qualification">Qualification</label>
                                <InputText className='p-w-100 p-mt-1' id="qualification" value={qualification} disabled={!isEdit} maxLength={30} onChange={(e) => handleChange(e, 'Qualification')} />
                            </div>
                        </div>
                        <div className="p-col-12 p-md-3">
                            <div className="custom-inputs">
                                <label className='p-d-block' htmlFor="occupation">Occupation</label>
                                <InputText className='p-w-100 p-mt-1' id="occupation" value={occupation} disabled={!isEdit} maxLength={20} onChange={(e) => handleChange(e, 'Occupation')} />
                            </div>
                        </div>
                        <div className="p-col-12 p-md-3">
                            <div className="custom-inputs">
                                <label className='p-d-block' htmlFor="designation">Designation</label>
                                <InputText className='p-w-100 p-mt-1' id="designation" value={designation} disabled={!isEdit} maxLength={20} onChange={(e) => handleChange(e, 'Designation')} />
                            </div>
                        </div>
                        <div className="p-col-12 p-md-3">
                            <div className="custom-inputs">
                                <label className='p-d-block' htmlFor="income">Annual Income</label>
                                <InputText className='p-w-100 p-mt-1' id="income" value={income} disabled={!isEdit} onChange={(e) => handleChange(e, 'Income')} />
                            </div>
                        </div>
                        <div className="p-col-12 p-md-3">
                            <div className="custom-inputs">
                                <label className='p-d-block' htmlFor="currentAddress">Current Address</label>
                                <InputTextarea className='p-w-100 p-mt-1' id="currentAddress" value={currentAddress} maxLength={100} type='textArea' rows={1} cols={30} onChange={(e) => setCurrentAddress(e.target.value)} disabled={!isEdit} />
                            </div>
                        </div>
                        <div className="p-col-12 p-md-3">
                            <div className="p-d-flex p-ai-center p-mt-4">
                                <Checkbox
                                    inputId="randomCheckbox"
                                    checked={isRandom}
                                    onChange={(e) => handleCheckBox(e)}
                                    disabled={!isEdit}
                                />
                                <label className='p-ml-2' htmlFor="randomCheckbox">Permanent address same as current</label>
                            </div>
                        </div>
                        <div className="p-col-12 p-md-3">
                            <div className="custom-inputs">
                                <label className='p-d-block' htmlFor="permanentAddress">Permanent Address</label>
                                <InputTextarea className='p-w-100 p-mt-1' id="permanentAddress" value={permanentAddress} maxLength={100} rows={1} cols={30} onChange={(e) => setPermanentAddress(e.target.value)} disabled={!isEdit} />
                            </div>
                        </div>
                        <div className="p-col-12 p-md-3">
                            <div className="custom-inputs">
                                <label className='p-d-block' htmlFor="children">Children</label>
                                <MultiSelect
                                    id="children"
                                    value={childrens}
                                    disabled={!isEdit}
                                    options={childrensList}
                                    onChange={(e) => setChildrens(e.value)}
                                    placeholder="Select Childrens"
                                    filter
                                    display="chip"
                                    className='p-w-100 p-mt-1'
                                />
                                <span className="error-msg" style={{ color: 'red' }}>
                                    {childrensErr ? childrensErrText : null}
                                </span>
                            </div>
                        </div>
                        <div className="p-col-12">
                            <DataTable
                                value={childrensDetailList}
                                responsiveLayout="scroll"
                                className='custom-table'
                            >
                                <Column field="id" body={actionBodyTemplateSrNo} header="Sr No." />
                                <Column field="name" header="Full Name" />
                                <Column field="gender" header="Gender" />
                                <Column field="phone" header="Contact No." />
                                <Column field="email" header="Email ID" />
                                <Column field="className" header="Class" />
                                <Column field="classTeacherName" header="Class Teacher" />
                            </DataTable>
                        </div>

                    </div>
                    <div className="p-d-flex p-ai-center p-jc-end">
                        <Button label="Back" className="p-my-0 p-mx-0 e-border-btn" onClick={() => navigate('/parent-master')} />
                        {isEdit ?
                            <Button className="btn-text-action-primary p-button p-component p-ml-2 p-mr-2 p-my-0" label="Save" onClick={() => saveDetails()} /> : null}
                    </div>
                </div>
                <Dialog
                    visible={isDeleteConfirmation}
                    onHide={handleClose}
                    header={
                        <div className="p-d-flex p-jc-between p-ai-center">
                            <span>Delete Confirmation</span>
                        </div>
                    }
                    footer={renderFooter()}
                    draggable={false}
                    dismissableMask
                    position="center"
                    style={{ width: '450px' }}
                >
                    <DeleteConfirmation />
                </Dialog>
            </div>

        </div>
    );
}

export default ViewEditParentDetails;
